import { createBrowserClient } from "@supabase/ssr";
import {
  BASE_URL,
  COUNTRY_CODE,
  SUPABASE_ANON_KEY,
  SUPABASE_URL,
} from "@utils/constants";
import { getCookieValue } from "@utils/helpers";
import axios from "axios";
import { useTranslations } from "next-intl";
import { mutate } from "swr";

export async function handlePatchBasketTicketName(
  name: string,
  ticketId: number,
  setSuccess: (message?: string) => void,
  setFailure: (message?: string, is500?: boolean) => void,
  translations?: ReturnType<typeof useTranslations<"Utils">>,
  onSuccess?: (name?: string) => void
) {
  const basketKey = getCookieValue("ASP.NET_SessionId");
  const websiteUid = getCookieValue("itk-website-uid");

  const response = await axios.patch(
    `${BASE_URL}/legacy/${COUNTRY_CODE}/shop/basket/${basketKey}/ticket/${ticketId}/name`,
    { uniqueId: ticketId, name },
    {
      headers: {
        "itk-website-uid": websiteUid,
      },
    }
  );

  if (response.status >= 200 && response.status < 300) {
    await mutate(`basket/${basketKey}`);
    await mutate(`basket/${basketKey}/form`);
    await mutate(`basket/${basketKey}/summary`);
    await mutate(`basket/${basketKey}/checkout`);
    await mutate(
      (key: any) =>
        Array.isArray(key) && key[0] === `basket/${basketKey}/checkout`
    );
    setSuccess(
      translations?.("ticketnameupdated") ?? `Successfully updated ticket name `
    );
    onSuccess?.(name);
  } else if (response.status >= 400 && response.status < 500) {
    setFailure(response.data.message);
  } else {
    setFailure(
      translations?.("somethingwentwrong") ?? "Something went wrong.",
      true
    );
  }
}

export async function handlePatchOrderTicketName(
  name: string,
  orderId: number,
  ticketId: number,
  setSuccess: (message?: string) => void,
  setFailure: (message?: string, is500?: boolean) => void,
  translations?: ReturnType<typeof useTranslations<"OrderHistory">>,
  onSuccess?: (name?: string) => void
) {
  const websiteUid = getCookieValue("itk-website-uid");
  const supabase = createBrowserClient(SUPABASE_URL!, SUPABASE_ANON_KEY!);
  const {
    data: { session },
  } = await supabase.auth.getSession();

  try {
    await axios.patch(
      `${BASE_URL}/legacy/${COUNTRY_CODE}/shop/order/${orderId}/ticket/${ticketId}/name`,
      {
        ticketName: name,
      },
      {
        headers: {
          "itk-website-uid": websiteUid,
          Authorization: `Bearer ${session?.access_token}`,
        },
      }
    );
    setSuccess(translations?.("updatedname", { name }));
    onSuccess?.(name);
  } catch (err) {
    console.error(err);
    setFailure(translations?.("failedupdatename") ?? "Failed to update name");
  }
}
